<template>
    <div class="SelectableImageBox">
        <div v-for="(item, index) in list" :key="index" class="SelectableImageBox-item" >
            <div class="badge" :style="{ width: size + 'px', height: size + 'px' }" :class="activeList.includes(type == 'main' ? item.src : item) ? 'active' : ''">
                <div class="mask" @click="openBigImg(type == 'main' ? item.src : item)">
                    <i class="custom-icon el-icon-zoom-in"></i>
                </div>
                <img :src="type == 'main' ? item.src : item" alt  @click="handleSelect(type == 'main' ? item.src : item, index, item)"/>
            </div>
            <div class="price" v-if="type == 'main'">
                价格: {{ item.price }} {{ item.currency }}
            </div>
        </div>
        <el-dialog
        :visible.sync="dialogVisible" top="3vh" custom-class="img-dialog" append-to-body close-on-click-modal close-on-press-escape center>
            <img :src="dialogSrc" class="dialog-img">
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: 'SelectableImageBox',
    inheritAttrs: false, // 避免重复绑定属性
    props: {
        list:{
            type: Array,
            default(){
                return [];
            }
        },
        fit:{
            type: String,
            default: 'contain'
        },
        size: {
            type: String,
            default: '100'
        },
        type: {
            type: String,
        },
        activeList:{
            type: Array,
            default() {
                return [];
            }
        },
        otherActiveList:{
            type: Array,
            default() {
                return [];
            }
        }
    },
    data() {
        return {
            dialogVisible: false,
            dialogSrc: '',
            lastSelectedIndex: null, // 上次点击的索引
            shiftPressed: false, // 是否按下了 Shift
        };
    },
    mounted() {
        window.addEventListener('keydown', this.handleKeyDown);
        window.addEventListener('keyup', this.handleKeyUp);
    },
    beforeDestroy() {
        window.removeEventListener('keydown', this.handleKeyDown);
        window.removeEventListener('keyup', this.handleKeyUp);
    },
    methods: {
        handleKeyDown(e) {
            if (e.key === 'Shift') this.shiftPressed = true;
        },
        handleKeyUp(e) {
            if (e.key === 'Shift') this.shiftPressed = false;
        },
        handleSelect(item, index, itemData) {
            if (this.shiftPressed && this.lastSelectedIndex !== null) { 

                // 按下shift选中的
                const start = Math.min(this.lastSelectedIndex, index); //开始位置
                const end = Math.max(this.lastSelectedIndex, index); //结束位置

                let mainList = []; //所选择的主图或者副图
                let otherList = []; //所选择的主图中包含的副图，主要type==mian的情况需要考虑

                let selectedItems = this.list.slice(start, end + 1);
                console.log(this.type);
                selectedItems.forEach(i => {
                    if(this.type == 'main'){
                        otherList.push(...i.otherSrc);
                        mainList.push(i.src)
                    }else{
                        mainList.push(i)
                    }
                })
                
                const allSelected = selectedItems.every(i => {
                    if(this.type == 'main'){
                        return this.activeList.includes(i.src)
                    }
                    return this.activeList.includes(i)
                });
                otherList = [...new Set(otherList)];

                let activeList;
                let childrenActiveList;
                if (allSelected) {
                    // 如果区间全部已选中，执行取消选中
                    activeList = this.activeList.filter(i => !mainList.includes(i));
                    if (this.type === 'main') {
                        childrenActiveList = this.otherActiveList.filter(i => !otherList.includes(i));
                    }
                } else {
                    // 否则添加选中项（去重）
                    activeList = Array.from(new Set([...this.activeList, ...mainList]));
                    if (this.type === 'main') {
                        childrenActiveList = Array.from(new Set([...this.otherActiveList, ...otherList]));
                    }
                }
                if(this.type == 'main'){
                    this.$emit('updOtherActiveList', childrenActiveList); //更新和主图关联的副图
                }
                this.$emit('updActiveList', activeList);
            } else {
                // 普通点击：切换选中状态
                const i = this.activeList.indexOf(item);
                let otherActiveList = [];
                if (i === -1) { //不包含
                    this.activeList.push(item);
                    otherActiveList = Array.from(new Set([...this.otherActiveList, ...(itemData.otherSrc ? itemData.otherSrc : [''])]));
                } else {
                    this.activeList.splice(i, 1);
                    otherActiveList = this.otherActiveList.filter(item => {
                        return !itemData.otherSrc.includes(item)
                    })
                }
                this.lastSelectedIndex = index;
                this.$emit('updActiveList', [...this.activeList]); // 确保更新
                if(this.type == 'main'){
                    this.$emit('updOtherActiveList', otherActiveList); //更新和主图关联的副图
                }

            }
        },
        changeState(url){
            if(this.activeList.includes(url)){
                const index = this.activeList.indexOf(url);
                this.activeList.splice(index, 1);
            }else{
                this.activeList.push(url);
            }
        },
        openBigImg(src){
            this.dialogSrc = src;
            this.dialogVisible = true;
        }
    }
};
</script>
<style lang="scss" scoped>
.SelectableImageBox{
    display: flex;
    flex-wrap: wrap;
    .SelectableImageBox-item{
        margin-right: 10px;
        margin-bottom: 10px;
        cursor: pointer;
        position: relative;
        box-sizing: border-box;
        border: 1px solid #dcdcdc;
        &:hover .mask{
            background: rgba(0, 0, 0, 0.5);
        }
        .price{
            // position: absolute;
            background-color: #fff;
            left: 1px;
            top: 1px;
            padding: 0 5px;
            color: green;
            font-weight: bold;
        }
        .badge{
            position: relative;
            width: 100%;
            height: 100%;
            box-sizing: border-box;
            border: 2px solid rgba(0, 0, 0, 0);
            &.active{
                border-color: green;
                border: 2px solid green;
                /* 右上角对勾标记 */
                /* 右上角三角形背景的对勾标记 */
                &::after {
                    content: '';
                    position: absolute;
                    top: 0;
                    right: 0;
                    width: 0;
                    height: 0;
                    border-top: 30px solid green;
                    /* 三角形高度 */
                    border-left: 30px solid transparent;
                    /* 控制三角形宽度 */
                    z-index: 10;
                }
            
                /* 对勾符号 */
                &::before {
                    content: '✓';
                    position: absolute;
                    top: -2px;
                    right: 0;
                    color: white;
                    font-size: 16px;
                    font-weight: bold;
                    z-index: 20;
                }
            }
            img{
                width: 100%;
                height: 100%;
                object-fit: contain;
            }
        }
        .mask {
            width: 100%;
            height: 20%;
            display: flex;
            justify-content: center;
            align-items: center;
            background: rgba(0, 0, 0, 0.2);
            position: absolute;
            bottom: 0;
            left: 0;
            transition-duration: 0.5s;
            .custom-icon {
                font-size: 20px;
                margin: 0 8px;
                color: #fff;
            }
        }
    }
}
.el-image {
    border: 1px solid #dcdcdc;
    margin-right: 10px;
    margin-bottom: 10px;
    cursor: pointer;
    position: relative;
    box-sizing: border-box;
        /* 确保定位基准 */
    
}
/deep/ .img-dialog{
    .el-dialog__body{
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        max-height: none;
    }
}
.dialog-img{
    height: 860px;
    width: 860px;
    object-fit: contain;
}
</style>
